import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { _formatSqlQuery } from '@shared/aux_helper_functions';

@Component({
  selector: 'ai-dashboard-error-details-modal',
  templateUrl: './ai-dashboard-error-details-modal.component.html',
  styleUrls: ['./ai-dashboard-error-details-modal.component.scss'],
})
export class AiDashboardErrorDetailsModalComponent {
  constructor(
    public dialogRef: MatDialogRef<AiDashboardErrorDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { errorDetails: any }
  ) {
    this.dialogRef.disableClose = false;
  }

  close(): void {
    this.dialogRef.close();
  }

  get formattedSqlQuery(): string {
    if (!this.data.errorDetails?.sqlQuery) return '';
    return _formatSqlQuery(this.data.errorDetails.sqlQuery);
  }
}
